<template>
    <div v-if="loaded">
        <nav
            class="mx-4 border-b border-gray-dark md:flex md:justify-between md:items-end"
        >
            <h2 class="md:w-1/4 font-bold text-xl px-4 py-4">Magazines</h2>
            <div v-if="magazines && magazines.length > 0" class="py-4">
                <a
                    @click.prevent="createMagazine"
                    class="bg-primary text-white text-sm px-2 py-1 rounded cursor-pointer"
                >
                    <font-awesome-icon
                        :icon="['fas', 'plus']"
                        class="icon"
                    ></font-awesome-icon>
                </a>
            </div>
        </nav>
        <div
            v-if="magazines && magazines.length > 0"
            class="my-2 px-2 flex items-start"
        >
            <div class="w-full px-1 rounded">
                <section class="mt-2 text-sm">
                    <div
                        class="border-b border-gray-dark hover:bg-gray-light"
                        v-for="magazine of magazines"
                        :key="magazine.id"
                    >
                        <a
                            class="p-2 flex items-center justify-between"
                            :href="'magazines/' + magazine.id"
                        >
                            <div class="min-w-0">
                                <header class="flex justify-between">
                                    <div
                                        class="flex items-center min-w-0 gap-1"
                                    >
                                        <p class="font-bold truncate ml-1">
                                            <span class="md:inline">{{
                                                magazine.name
                                            }}</span>
                                        </p>
                                        <span
                                            class="text-gray-darker next-delivery-message"
                                        >
                                            {{
                                                magazine.next_delivery_at
                                            }}</span
                                        >
                                    </div>
                                </header>
                                <section
                                    class="py-1 ml-1"
                                    v-if="magazine.last_delivery_at"
                                >
                                    Last delivered on
                                    {{ magazine.last_delivery_at }} ({{
                                        magazine.last_delivery_count
                                    }}
                                    emails inside)
                                </section>
                                <section class="py-1 ml-1" v-else>
                                    This magazine hasn't been delivered even
                                    once yet.
                                </section>
                            </div>
                        </a>
                    </div>
                </section>
            </div>
        </div>
        <div class="my-12" v-else>
            <div class="text-center">
                <p class="mx-2 xl:mx-32 my-4 font-bold text-primary">
                    Bundle up multiple emails into an single email, delivered at
                    the day and time of your choice.
                </p>
                <p class="mx-2 xl:mx-32 my-4 font-bold text-primary">
                    They are great for 📰 newsletters or 🔔 notifications.
                </p>
                <a
                    @click.prevent="createMagazine"
                    class="inline-block my-4 py-2 px-4 rounded-md bg-primary text-white font-bold cursor-pointer"
                    >Create New Magazine</a
                >
            </div>
        </div>
    </div>
    <div v-else>
        <loading />
    </div>
</template>
<script>
import createMagazineModal from "./CreateMagazineModal.vue";

export default {
    name: "magazines",
    data() {
        return {
            parentCheckbox: false,
            search: "",
            currentId: "",
            isOpen: false,
            loaded: false,
            selected: {},
            magazines: [],
        };
    },
    mounted() {
        this.loadMagazine();
    },
    methods: {
        loadMagazine() {
            axios
                .get(`api/magazines`)
                .then((response) => {
                    this.magazines = response.data.data;
                    this.loaded = true;
                })
                .catch(console.error);
        },
        toggle(id) {
            this.currentId = id;
            this.isOpen = !this.isOpen;
        },
        createMagazine() {
            Modal.show(createMagazineModal)
                .then((response) => {
                    this.loadMagazine();
                })
                .catch(console.error);
        },
    },
};
</script>
<style lang="scss"></style>
